import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Grid,
  Box,
  Stack,
  Dialog,
  Backdrop,
  DialogActions,
} from "@mui/material";
import "./TaskAssignment.css";
import { taskAssign } from "../../config/images";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TaskDetail from "./TaskDetail";
import {
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Switch,
  FormControlLabel,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { addTaskAssignment, getDataCollectorList, getLocalGovernmentDetails, getLocalGovernmentList, getRegionList, getStateDetails, getStateList, getTaskAssignment } from "../../config/services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import translations from "../../config/language";
import { Button } from "../../components/Button/button";

const TaskAssignment = () => {
  // const [showTaskDetail, setShowTaskDetail] = useState(false);
  const [assignModal, setAssignModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [filterAnchor, setFilterAnchor] = useState(null);

  const [showTaskDetail, setShowTaskDetail] = useState(
    localStorage.getItem("showTaskDetail") == "true"
  );

  const notify = (message) => {
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const notifySuccess = (message) => {
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };
  useEffect(() => {
    localStorage.setItem("showTaskDetail", showTaskDetail);
  }, [showTaskDetail]);

  const navigate = useNavigate();

  // const [tasks, setTasks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState();
  const [perPage, setPerPage] = useState(10);
  const [taskData, setTaskData] = useState({
    taskTitle: "",
    taskDescription: "",
    region: "",
    state: "",
    localGovernment: "",
    dataCollector: "",
    numberOfFarmers: null,
    deadline: null,
    notification: false,
  });

  const [tasks, setTasks] = useState([]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setTaskData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSwitchChange = (e) => {
    setTaskData((prev) => ({
      ...prev,
      notification: e.target.checked,
    }));
  };

  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
  const handleVisibilityClick = (id) => {
    // setShowTaskDetail(!showTaskDetail);
    navigate(`/task-assignment/${id}`);

  };

  const [filterValues, setFilterValues] = useState({
    status: "",
    fromDate: null,
    toDate: null,
  });

  const handleFilterClick = (event) => {
    setFilterAnchor(event.currentTarget); // Set filter icon position
    setFilterModal(true);
  };

  const handleFilterChange = (eventOrValue, fieldName) => {
    if (typeof eventOrValue === "object" && eventOrValue.target) {
      // This is an event from a Select or regular input
      const { name, value } = eventOrValue.target;
      setFilterValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else {
      // This is a direct value from DatePicker
      setFilterValues((prev) => ({
        ...prev,
        [fieldName]: eventOrValue,
      }));
    }
  };

  const handleClear = () => {
    setFilterValues({
      status: "",
      fromDate: null,
      toDate: null,
    });
    setFilterDataCollector("");
    setIsFilterData(false); // Disable filtering
    fetchTaskAssignment();  // Fetch without filters
  };

  const [regionData, setRegionData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [localGovernmentData, setLocalGovernmentData] = useState([]);
  const [dataCollectorData, setDataCollectorData] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(""); // Store selected region
  const [selectedState, setSelectedState] = useState(""); // Store selected state
  const [selectedLocalGov, setSelectedLocalGov] = useState(""); // Store selected Local government
  const [selectedDataCollector, setSelectedDataCollector] = useState(""); // Store selected Data collector
  const [filterDataCollector, setFilterDataCollector] = useState("") // Store Data collector for filter
  const [isFilteredData, setIsFilterData] = useState(false);

  const fetchData = async () => {
    const searchParams = { search: "" };
    const region = await getRegionList();
    setRegionData(region.data.results.payload);

    const dataCollectorData = await getDataCollectorList();
    setDataCollectorData(dataCollectorData.data.results.payload);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getStateBasedOnRegion = async (regionId) => {
    try {
      const resp = await getStateDetails(regionId);
      if (resp.data.results.success == true) {
        setStateData(resp.data.results.payload)
      }
    } catch (error) {
      console.log("error", error);
      notify(error.response.data.message);
    }
  };
  useEffect(() => {
    if (selectedRegion) {
      getStateBasedOnRegion(selectedRegion)
    }
  }, [selectedRegion]);

  const getLocalGovBasedOnState = async (stateId, regionId) => {
    const data = {
      region_id: regionId,
      state_id: stateId
    }
    try {
      const resp = await getLocalGovernmentDetails(data);
      if (resp.data.results.success == true) {
        setLocalGovernmentData(resp.data.results.payload)
      }
    } catch (error) {
      console.log("error", error);
      notify(error.response.data.message);
    }
  };
  useEffect(() => {
    if (selectedState && selectedRegion) {
      getLocalGovBasedOnState(selectedState, selectedRegion)
    }
  }, [selectedState, selectedRegion]);
  const [loading, setLoading] = useState(false);

  const handleAddTaskAssignment = async (e) => {
    e.preventDefault();
    if (!taskData.taskTitle) {
      notify("Please enter Task title")
      return true;
    }
    if (!taskData.taskDescription) {
      notify("Please enter Task description")
      return true;
    }

    if (!selectedRegion) {
      notify("Please select Region")
      return true;
    }
    if (!selectedState) {
      notify("Please select State")
      return true;
    }
    if (!selectedLocalGov) {
      notify("Please select Local Government")
      return true;
    }
    if (!selectedDataCollector) {
      notify("Please select Data Collector")
      return true;
    }
    if (!taskData.numberOfFarmers) {
      notify("Please enter No of farmers")
      return true;
    }
    if (!taskData.deadline) {
      notify("Please enter Deadline");
      return true;
    }


    const params = {
      deadline_of_task: taskData.deadline
        ? dayjs(taskData.deadline).format("YYYY-MM-DD")
        : null,
      title: taskData.taskTitle,
      description: taskData.taskDescription,
      number_of_farmers: taskData.numberOfFarmers,
      is_notification: taskData.notification,
      region: selectedRegion,
      state: selectedState,
      local_government: selectedLocalGov,
      data_collector: selectedDataCollector.id,
      created_by: "",
    };

    try {
      setLoading(true);
      const resp = await addTaskAssignment(params);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setAssignModal(false);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
        setTaskData({
          taskTitle: "",
          taskDescription: "",
          region: "",
          state: "",
          localGovernment: "",
          dataCollector: "",
          numberOfFarmers: null,
          deadline: null,
          notification: false,
        });
        setSelectedDataCollector("");
        setSelectedRegion("");
        setSelectedState("");
        setSelectedLocalGov("");

        fetchTaskAssignment();
      }
    } catch (error) {
      console.log("error", error);
      notify(error.response.data.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  const fetchTaskAssignment = async () => {

    const data = isFilteredData
      ? {
        data_collector__id: filterDataCollector?.id,
        status: filterValues.status,
        start_datetime: filterValues.fromDate ? dayjs(filterValues.fromDate).format("YYYY-MM-DD HH:mm:ss") : null,
        end_datetime: filterValues.toDate ? dayjs(filterValues.toDate).format("YYYY-MM-DD 23:59:59") : null,
      }
      : {}; // If not filtered, send an empty object

    try {
      const resp = await getTaskAssignment(data, currentPage, perPage);
      if (resp.data.results.success == true) {
        setTasks(resp.data.results.payload);
        setCount(resp.data.count);
        setIsFilterData(false);
      }
    } catch (error) {
      console.log("error", error);
      notify(error.response.data.message);
    }
  }
  const handleFilterSubmit = () => {
    setIsFilterData(true);
    setFilterModal(false);
  }

  useEffect(() => {
    if (isFilteredData) {
      fetchTaskAssignment();
    }
  }, [isFilteredData])
  useEffect(() => {
    fetchTaskAssignment();
  }, []);

  const language = process.env.REACT_APP_LANGUAGE;

  const NotificationSwitch = styled(Switch)(({ theme }) => ({
    padding: 8,
    width: 70,
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      width: "100%",
      '&::before, &::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 70,
        height: 16,
        fontSize: 12,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '&::before': {
        content: '"OFF"',
        left: 8, // Position the "ON" label
        color: "#FFFFFF",
        fontWeight: 'bold',
      },
      '&::after': {
        content: '"ON"',
        right: 12, // Position the "OFF" label
        color: theme.palette.text.secondary,
        fontWeight: 'bold',
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: 16,
      height: 16,
      margin: 2,
      transform: 'translateX(0px)',
    },
  }));

  return (
    <>
      {!showTaskDetail && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box className="task-assign-box">
              <Box className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap" }}>
                <Box
                  className="d-flex gap-3 img-box"
                  style={{ padding: "25px" }}
                >
                  <img src={taskAssign.union} alt="" />
                  <Typography variant="h6" gutterBottom>
                    {translations[language].taskAssignment}
                  </Typography>
                </Box>
                <Box className="assign-data-btn">
                  <img
                    src={taskAssign.filter}
                    alt=""
                    style={{ cursor: "pointer" }}
                    onClick={handleFilterClick}
                  />
                  <button
                    className="assign-task-btn"
                    onClick={() => setAssignModal(true)}
                  >
                    {translations[language].taskAssign}
                  </button>
                </Box>
              </Box>
              <Box style={{ width: '100%', overflowX: 'auto' }}>
                <Table className="task-assign-table">
                  <TableHead>
                    <TableRow>
                      <TableCell>{translations[language].srNo}</TableCell>
                      <TableCell>{translations[language].dataCollector}</TableCell>
                      <TableCell>{translations[language].description}</TableCell>
                      <TableCell>{translations[language].region}</TableCell>
                      <TableCell>{translations[language].state}</TableCell>
                      <TableCell>{translations[language].localGovernment}</TableCell>
                      <TableCell>{translations[language].noOfFarmers}</TableCell>
                      <TableCell>{translations[language].deadline}</TableCell>
                      <TableCell>{translations[language].statusView}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tasks.map((task, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ textAlign: "center" }}>{index + 1 + (currentPage - 1) * perPage}</TableCell>
                        <TableCell>{task.data_collector_name}</TableCell>
                        <TableCell>{task.description}</TableCell>
                        <TableCell>{task.region_name}</TableCell>
                        <TableCell>{task.state_name}</TableCell>
                        <TableCell>{task.local_government_name}</TableCell>
                        <TableCell>{task.number_of_farmers}</TableCell>
                        <TableCell>{dayjs(task.deadline_of_task).format("DD/MM/YYYY")}</TableCell>
                        <TableCell>
                          <div className="d-flex gap-4">
                            {/* <div style={{ width: "50px", color: task.is_active == false ? "#31A05F" : "" }} */}
                            <div style={{ width: "50px", color: task.status == "7" ? "#31A05F" : "" }}

                            >
                              {task.status == 6 ? translations[language].pending : translations[language].completed}
                            </div>
                            <VisibilityIcon
                              onClick={() => handleVisibilityClick(task.id)}
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
              <Box display="flex" justifyContent="end" alignItems="center">
                <Stack spacing={2} className="mb-2">
                  <CustomPagination
                    count={Math.ceil(count / perPage)}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                  />
                </Stack>
              </Box>
              {/* Filter Popup */}
              <Dialog
                open={filterModal}
                onClose={() => setFilterModal(false)}
                className="filter-popup"
                maxWidth="xs"
                fullWidth
                disableScrollLock
              >
                <DialogContent style={{ padding: "15px" }} >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 0,
                      mt: 0,
                    }}
                  >
                    <Typography variant="h6" style={{ marginLeft: "5px" }}>{translations[language].filter}</Typography>
                    <Typography onClick={handleClear} sx={{ color: "#666", cursor: "pointer" }}>
                      {translations[language].clear}
                    </Typography>
                  </Box>

                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <FormControl fullWidth size="mb-3">
                      {/* <InputLabel>{translations[language].selectDataCollector}</InputLabel> */}
                      {/* <Select
                        label="Select Data Collector"
                        value={filterDataCollector}
                        onChange={(e) => setFilterDataCollector(e.target.value)}
                        IconComponent={ArrowDropDownIcon}
                        className="filter-select"
                        name="dataCollector"
                      >
                        {dataCollectorData.map((item, index) => (
                          <MenuItem value={item.id}>
                            {item.first_name} {item.middle_name} {item.last_name}
                          </MenuItem>
                        ))}
                      </Select> */}
                      <Autocomplete
                        name="dataCollector"
                        value={filterDataCollector || null} // Ensure that selectedDataCollector is an object with appropriate properties
                        onChange={(e, newValue) => setFilterDataCollector(newValue)}  // Set the selected value
                        options={dataCollectorData}  // Pass options as an array of items
                        getOptionLabel={(option) => `${option.first_name} ${option.middle_name} ${option.last_name}`}  // Format the display label
                        renderInput={(params) => <TextField {...params} label={translations[language].selectDataCollector} />}  // Correct way to render input with label
                        isOptionEqualToValue={(option, value) => option.id === value?.id}  // Ensure proper comparison of option and selected value
                      />
                    </FormControl>
                    <FormControl fullWidth size="mb-3">
                      <InputLabel>{translations[language].selectStatus}</InputLabel>
                      <Select
                        value={filterValues.status}
                        onChange={handleFilterChange}
                        label="Select Status"
                        IconComponent={ArrowDropDownIcon}
                        className="filter-select"
                        name="status"
                      >
                        <MenuItem value="" hidden>

                        </MenuItem>
                        <MenuItem value={7}>{translations[language].completed}</MenuItem>
                        <MenuItem value={6}>{translations[language].pending}</MenuItem>
                      </Select>
                    </FormControl>

                    <div style={{ display: "flex", gap: "10px" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label={translations[language].fromDate}
                          value={filterValues.fromDate}
                          name="fromDate"
                          onChange={(value) => handleFilterChange(value, "fromDate")}
                        />
                      </LocalizationProvider>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label={translations[language].toDate}
                          value={filterValues.toDate}
                          name="toDate"
                          onChange={(value) => handleFilterChange(value, "toDate")}
                        />
                      </LocalizationProvider>
                    </div>
                    <Button
                    title={translations[language].submit}
                      onClick={handleFilterSubmit}
                      classname={"assign-task-button"}
                    />
                  </Box>
                </DialogContent>
              </Dialog>
              <Dialog
                open={assignModal}
                onClose={() => setAssignModal(false)}
                maxWidth="xs"
                fullWidth
                disableScrollLock
                PaperProps={{
                  sx: { borderRadius: "12px" },
                }}
              // className="dialog-assign"
              >
                <div className="assign-div">
                  {" "}
                  <div className="d-flex justify-content-around align-items-center">
                    <h5
                      className="p-3 mb-0"
                      style={{ textAlign: "center", marginLeft: "118px" }}
                    >
                      {translations[language].assignTask}
                    </h5>
                    <img
                      src={taskAssign.closeIcon}
                      alt=""
                      style={{
                        height: "30px",
                        width: "30px",
                        cursor: "pointer",
                        marginLeft: "95px",
                      }}
                      onClick={() => setAssignModal(false)}
                    />
                  </div>
                </div>
                <DialogContent>
                  <TextField
                    fullWidth
                    label={translations[language].enterTaskTitle}
                    name="taskTitle"
                    value={taskData.taskTitle}
                    // onChange={handleChange}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Allow limit to 50 characters
                      if (inputValue.length <= 50) {
                        handleChange(e);
                      }
                    }}
                    className="mb-3"
                  />
                  <TextField
                    fullWidth
                    id="outlined-multiline-static"
                    label={translations[language].taskDescription}
                    name="taskDescription"
                    value={taskData.taskDescription}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Allow limit to 150 characters
                      if (inputValue.length <= 150) {
                        handleChange(e);
                      }
                    }}
                    multiline
                    rows={3}
                    className="textarea-taskDescription mb-3"
                  />
                  <FormControl fullWidth className="mb-3">
                    <InputLabel>{translations[language].selectRegion}</InputLabel>
                    <Select
                      label={translations[language].selectRegion}
                      name="region"
                      value={selectedRegion}
                      onChange={(e) => setSelectedRegion(e.target.value)}
                    >
                      {regionData.map((item, index) => (
                        <MenuItem value={item.id}>{item.region_name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth className="mb-3">
                    <InputLabel>{translations[language].selectState}</InputLabel>
                    <Select
                      label={translations[language].selectState}
                      name="state"
                      value={selectedState}
                      onChange={(e) => setSelectedState(e.target.value)}
                    >
                      {stateData.map((item, index) => (
                        <MenuItem value={item.id}>{item.state_name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth className="mb-3">
                    <InputLabel>{translations[language].selectLocalGovernment}</InputLabel>
                    <Select
                      label={translations[language].selectLocalGovernment}
                      name="localGovernment"
                      value={selectedLocalGov}
                      onChange={(e) => setSelectedLocalGov(e.target.value)}
                    >
                      {localGovernmentData.map((item, index) => (
                        <MenuItem value={item.id}>
                          {item.local_government_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth className="mb-3">
                    {/* <InputLabel>{translations[language].selectDataCollector}</InputLabel> */}
                    <Autocomplete
                      name="dataCollector"
                      value={selectedDataCollector || null} // Ensure that selectedDataCollector is an object with appropriate properties
                      onChange={(e, newValue) => setSelectedDataCollector(newValue)}  // Set the selected value
                      options={dataCollectorData}  // Pass options as an array of items
                      getOptionLabel={(option) => `${option.first_name} ${option.middle_name} ${option.last_name}`}  // Format the display label
                      renderInput={(params) => <TextField {...params} label={translations[language].selectDataCollector} />}  // Correct way to render input with label
                      isOptionEqualToValue={(option, value) => option.id === value?.id}  // Ensure proper comparison of option and selected value
                    />
                  </FormControl>
                  <TextField
                    fullWidth
                    label={translations[language].enterNumberOfFarmers}
                    name="numberOfFarmers"
                    value={taskData.numberOfFarmers}
                    onChange={handleChange}
                    className="mb-3"
                    type="number"
                  />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label={translations[language].deadline}
                      value={taskData.deadline}
                      name="deadline"
                      onChange={(date) =>
                        setTaskData((prev) => ({ ...prev, deadline: date }))
                      }
                      minDate={dayjs().startOf('day')}
                    />
                  </LocalizationProvider>
                  <FormControlLabel
                    control={
                      <NotificationSwitch
                        checked={taskData.notification}
                        onChange={handleSwitchChange}
                        inputProps={{ "aria-label": "notification switch" }}
                      />
                    }
                    label={translations[language].notification}
                    className="mb-2 mt-2"
                    labelPlacement="start"
                    style={{ marginLeft: "0px" }}
                  />
                  {/* <button
                    className="assign-task-button"
                    onClick={(e) => handleAddTaskAssignment(e)}
                  >
                    {loading ? <span className="spinner"></span> : translations[language].assignTask}
                  </button> */}
                  <Button
                    title={translations[language].assignTask}
                    classname={"assign-task-button"}
                    onClick={handleAddTaskAssignment}
                    loading={loading}
                  />
                </DialogContent>
              </Dialog>
            </Box>
          </Grid>
        </Grid>
      )}
      {/* {showTaskDetail && (
        // <TaskDetail
        //   showTaskDetail={showTaskDetail}
        //   setShowTaskDetail={setShowTaskDetail}
        // />
      )} */}
    </>
  );
};

export default TaskAssignment;
